<template>
  <div class="row">
    <div class="col-10">
      <mark>{{ item.title }}</mark>
    </div>
    <div class="row__img">
      <div class="col-2"  v-if="item.srcset_1">
        <picture>
          <source v-bind:srcset=item.srcset_1>
          <img v-bind:src=item.src_1 alt="">
        </picture>
        <p>{{ item.text_1 }}</p>
      </div>
      <div class="col-2"  v-if="item.srcset_2">
        <picture>
          <source v-bind:srcset=item.srcset_2>
          <img v-bind:src=item.src_2 alt="">
        </picture>
        <p>{{ item.text_2 }}</p>
      </div>
      <div class="col-2" v-if="item.srcset_3">
        <picture>
          <source v-bind:srcset=item.srcset_3>
          <img v-bind:src=item.src_3 alt="">
        </picture>
        <p>{{ item.text_3 }}</p>
      </div>
      <div class="col-2" v-if="item.srcset_4">
        <picture>
          <source v-bind:srcset=item.srcset_4>
          <img v-bind:src=item.src_4 alt="">
        </picture>
        <p>{{ item.text_4 }}</p>
      </div>
      <div class="col-2" v-if="item.srcset_5">
        <picture>
          <source v-bind:srcset=item.srcset_5>
          <img v-bind:src=item.src_5 alt="">
        </picture>
        <p>{{ item.text_5 }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServicesRepairItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  components: {},
  methods: {},
  computed: {},
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
.row {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
  .col-10 {
    flex: 0 0 100%;
    max-width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding: 40px 0 20px 0;
    mark {
      padding: 7px 30px 7px 7px;
      font-weight: 500;
      font-size: 1.8rem;
    }
    @media (max-width: 997.98px) {
      padding: 30px 0 20px 0;
    }
  }
  .row__img {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    margin: 0 -5px;
    @media (max-width: 997.98px) {
      overflow-y: scroll;
      flex-wrap: nowrap;
    }
  }
  .col-2 {
    flex: 0 0 20%;
    max-width: 20%;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    padding: 0 5px;
    @media (max-width: 997.98px) {
      flex: 0 0 250px;
      max-width: 250px;
    }
    @media (max-width: 575.98px) {
      flex: 0 0 200px;
      max-width: 200px;
    }
    img {
      height: 200px;
      width: 100%;
      object-fit: cover;
      object-position: center;
      @media (max-width: 997.98px) {
        height: 250px;
      }
      @media (max-width: 575.98px) {
        height: 200px;
      }
    }
    p {
      font-weight: 300;
      font-size: 1.6rem;
      color: #4F4F4F;
      position: relative;
      padding-left: 14px;
      margin-top: 15px;
      &:before {
        content: '';
        position: absolute;
        width: 7px;
        height: 7px;
        top: 3px;
        left: 0;
        background: #000000;
      }
    }
  }
}
</style>
